<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4>{{ title }}</h4>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <form [formGroup]="form">
                <mat-form-field class="w-100">
                    <textarea matInput name="rechazo" rows="4" placeholder="Motivo del rechazo"
                        formControlName="rechazo"></textarea>
                    <mat-hint>Indique el motivo del rechazo</mat-hint>
                    <mat-error *ngIf="form.controls['rechazo'].hasError('required')">
                        <small>
                            El motivo del rechazo es <strong>obligatorio</strong>
                        </small>
                    </mat-error>
                </mat-form-field>
            </form>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <div class="d-flex justify-content-center">
                <button mat-stroked-button (click)="rechazar()" class="btn-warning">
                    <mat-icon>close</mat-icon>
                    Rechazar
                </button>
                <button mat-stroked-button (click)="cancel()" class="ms-3">
                    <mat-icon>cancel</mat-icon>
                    Cancelar
                </button>
            </div>
        </div>
    </div>
</div>